import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { memo, useState } from "react";
import { avatarListClasses } from "./AvatarList";
import { Box } from "./Box";
import { Image } from "./Image";
import { Svg } from "./Svg";
import { Typography } from "./Typography";
import { ColorsProvider } from "../providers/ColorsProvider";
import { SlotsProvider } from "../providers/SlotsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
export const userAvatarClasses = {
    root: "MinervaUserAvatar-root",
    image: "MinervaUserAvatar-image",
    alt: "MinervaUserAvatar-alt",
};
export const EmptyUser = (props) => (_jsxs(Svg, { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props, children: [_jsxs("g", { clipPath: "url(#clip0_157_3932)", children: [_jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.4002 8.4C17.4002 11.3823 14.9826 13.8 12.0002 13.8C9.01788 13.8 6.60022 11.3823 6.60022 8.4C6.60022 5.41766 9.01788 3 12.0002 3C14.9826 3 17.4002 5.41766 17.4002 8.4ZM15.6002 8.4C15.6002 10.3882 13.9884 12 12.0002 12C10.012 12 8.40022 10.3882 8.40022 8.4C8.40022 6.41177 10.012 4.8 12.0002 4.8C13.9884 4.8 15.6002 6.41177 15.6002 8.4Z", fill: "currentColor" }), _jsx("path", { d: "M12.0002 16.5C6.17327 16.5 1.20857 19.9456 -0.682617 24.7728C-0.221912 25.2303 0.263407 25.663 0.771179 26.0689C2.17945 21.6369 6.59727 18.3 12.0002 18.3C17.4032 18.3 21.821 21.6369 23.2293 26.0689C23.737 25.6631 24.2224 25.2303 24.6831 24.7729C22.7919 19.9456 17.8272 16.5 12.0002 16.5Z", fill: "currentColor" })] }), _jsx("defs", { children: _jsx("clipPath", { id: "clip0_157_3932", children: _jsx("path", { d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z", fill: "white" }) }) })] }));
export const userAvatarSlots = {
    image: Image,
    altText: Typography,
    fallbackIcon: EmptyUser,
};
export const UserAvatar = memo((props) => {
    const { src, alt, size = "md", color = "primary", colorSet = "container", invertColors, slots, slotProps, className, sx, ...rest } = useDefaultProps({ component: "UserAvatar", props });
    const [imgError, setImgError] = useState(false);
    const sizing = {
        xxs: 6,
        xs: 6.5,
        sm: 8,
        md: 10,
        lg: 14,
        xl: 18,
    };
    return (_jsx(SlotsProvider, { baseSlots: userAvatarSlots, slots: slots, children: ({ image: Image, altText: AltText, fallbackIcon: FallbackIcon }) => (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: invertColors, children: (colorStyles) => (_jsx(Box, { className: clsx([
                    userAvatarClasses.root,
                    avatarListClasses.avatar,
                    className,
                ]), sx: mergeSx({
                    ...colorStyles,
                    borderRadius: (theme) => theme.radius.full,
                    width: typeof size === "number" ? size : sizing[size],
                    height: typeof size === "number" ? size : sizing[size],
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: 1,
                    borderColor: (theme) => theme.palette.background.main,
                    overflow: "hidden",
                }, sx), ...rest, children: src && !imgError ? (_jsx(Image, { src: src, alt: alt, onError: () => setImgError(true), ...slotProps?.image, sx: {
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        ...slotProps?.image?.sx,
                    }, className: clsx([
                        userAvatarClasses.image,
                        slotProps?.image?.className,
                    ]) })) : alt ? (_jsx(AltText, { variant: size === "xxs" ? "title4" : "title3", fontWeight: "semibold", ...slotProps?.altText, className: clsx([
                        userAvatarClasses.alt,
                        slotProps?.altText?.className,
                    ]), children: alt
                        .split(" ")
                        .map((n, i, a) => i === 0 || i + 1 === a.length ? n[0] : null)
                        .join("") }, "userAvatar-alt-text")) : (_jsx(FallbackIcon, { ...slotProps?.fallbackIcon })) })) })) }));
});
//# sourceMappingURL=UserAvatar.js.map